import "./App.css"

const SidePlace = ({cardNumber, name, expDate, expDateD, cvc}) =>{
return(
    <div className="wrapper">
     <div className="cards">
        <div className="circle-wrapper">
        <div className="circle"></div>
    <div className="s-circle"></div>
        </div>
      <div className="card-input-com">
      <p className="input">{cardNumber}</p>  
      </div>
      <div className="name-and-date">
        <div className="name-date-wrapper">
            <div>{name}</div>
            <div>{expDate}/ {expDateD}</div>
        </div>
    </div>

     </div>
     <div className="card-two">
      <p>{cvc}</p>
     </div>
    </div>
    )
}

export default SidePlace